export default __webpack_public_path__ + "static/head_en-0471352c6d2ea4a5211492c3f749831f.png";